export default __webpack_public_path__ + "static/media/product-management.afddc0c9.svg";